<template>
  <b-container class="wh-incidences-monitor" fluid>
    <div style="position: relative; max-height: 100vh;" id="monitor" :class="viewType === 'tv' ? 'overflow-hidden' : 'overflow-auto'">
      <div id="inner-monitor" style="position:relative">
        <b-row>
          <b-col class="align-self-center py-1">
            <h5>
              <span v-translate="{countdown}">WH Incidences Monitor <small>(Autorefresh in %{countdown}s)</small></span>
              <b-link size="sm" class="p-0" v-b-modal.modalConfigMonitor><font-awesome-icon size="sm" icon="cog" /></b-link>
              <b-spinner small v-if="working" /></h5>
          </b-col>
          <b-modal size="sm" id="modalConfigMonitor" ref="modalConfigMonitor" hide-footer hide-header>
            <b-row>
              <b-col class="text-center">
                <b-button-group size="lg">
                  <b-button @click.prevent="viewType = 'tv'; setIntervalChangeScreen(); $refs.modalConfigMonitor.hide();" :disabled="viewType === 'tv'"><font-awesome-icon size="sm" icon="tv" /></b-button>
                  <b-button @click.prevent="viewType = 'list'; if(screenScroller) screenScroller.stop(); screenScroller = null; $refs.modalConfigMonitor.hide();" :disabled="viewType === 'list'"><font-awesome-icon size="sm" icon="list" /></b-button>
                  <b-button @click.prevent="viewType = 'grid'; if(screenScroller) screenScroller.stop(); screenScroller = null;  $refs.modalConfigMonitor.hide();" :disabled="viewType === 'grid'"><font-awesome-icon size="sm" icon="th" /></b-button>
                </b-button-group>
              </b-col>
            </b-row>
          </b-modal>
          <b-col class="align-self-center py-1">
            <div v-if="warehousesSelect.length > 0">
              <b-form-group class="mb-1">
                <b-form-select size="sm" v-model="filterWarehouse" :options="warehousesSelect">
                  <template slot="first">
                    <option :value="null" v-translate>None</option>
                  </template>
                </b-form-select>
              </b-form-group>
            </div>
          </b-col>
          <b-col class="align-self-center">
            <b-form-group class="mb-1">
              <b-form-select size="sm" v-model="countryOverride" :options="window.countries.map(x => { return {value: x.iso_code, text: x.name} })" @change="setNewCountry" v-if="isInternational">
                <template slot="first">
                  <option :value="null" v-translate>Select Country</option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-alert variant="warning" :show="connectionError">
          <span v-translate="{countdownConnectionError}">There are connection errors. Retrying in %{countdownConnectionError}s.</span>
        </b-alert>

        <b-alert variant="warning" class="my-3" show v-if="!countryOverride || !filterWarehouse || (countryOverride && warehousesSelect.length === 0)">
          <h4 class="my-0" v-translate>You need to set a Country and the Country must have warehouses set.</h4>
        </b-alert>
        <b-row id="data">
          <b-col cols="12" v-for="(subject, i) in couriers" :key="'list' + i" v-if="viewType === 'list' && countryOverride && warehousesSelect.length > 0">
            <b-card :bg-variant="subject.bg" :text-variant="subject.fg" class="mb-1">
              <strong>{{ subject.name }}</strong> ({{ subject.readableDistanceToDestination }}, {{ subject.eta }})
              <b-badge variant="danger">
                {{subject.shippings.filter(x => x.status_history[0].created_at < moment().utc().subtract(2, 'days').format('YYYY-MM-DD HH:mm:ss')).length}}
              </b-badge>
              <b-badge variant="warning">
                {{subject.shippings.filter(x => x.status_history[0].created_at < moment().utc().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss') && x.status_history[0].created_at > moment().utc().subtract(2, 'days').format('YYYY-MM-DD HH:mm:ss')).length}}
              </b-badge>
              <b-badge variant="success">
                {{subject.shippings.filter(x => x.status_history[0].created_at < moment().utc().subtract(6, 'hours').format('YYYY-MM-DD HH:mm:ss') && x.status_history[0].created_at > moment().utc().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')).length}}
              </b-badge>
              <span class="d-inline-block ml-2">{{subject.companies.join(', ')}}</span>
            </b-card>
          </b-col>
          <b-col cols="3" v-for="(subject, i) in couriers" :key="'grid' + i" v-if="viewType === 'grid' && countryOverride && warehousesSelect.length > 0">
            <b-card :bg-variant="subject.bg" :text-variant="subject.fg" class="mb-1 p-0">
              <div><strong>{{ subject.name }}</strong> ({{ subject.readableDistanceToDestination }}, {{ subject.eta }})</div>
              <div>
                <b-badge variant="danger">
                  {{subject.shippings.filter(x => x.status_history[0].created_at < moment().utc().subtract(2, 'days').format('YYYY-MM-DD HH:mm:ss')).length}}
                </b-badge>
                <b-badge variant="warning">
                  {{subject.shippings.filter(x => x.status_history[0].created_at < moment().utc().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss') && x.status_history[0].created_at > moment().utc().subtract(2, 'days').format('YYYY-MM-DD HH:mm:ss')).length}}
                </b-badge>
                <b-badge variant="success">
                  {{subject.shippings.filter(x => x.status_history[0].created_at < moment().utc().subtract(6, 'hours').format('YYYY-MM-DD HH:mm:ss') && x.status_history[0].created_at > moment().utc().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')).length}}
                </b-badge>
              </div>
              <hr class="my-1" />
              <div>{{subject.companies.join(', ')}}</div>
            </b-card>
          </b-col>
          <b-col cols="3" v-for="(subject, i) in couriers" :key="'tv' + i" v-if="viewType === 'tv' && countryOverride && warehousesSelect.length > 0">
            <b-card :bg-variant="subject.bg" :text-variant="subject.fg" class="mb-1 p-0">
              <div><strong>{{ subject.name }}</strong> ({{ subject.readableDistanceToDestination }}, {{ subject.eta }})</div>
              <div>
                <b-badge variant="danger">
                  {{subject.shippings.filter(x => x.status_history[0].created_at < moment().utc().subtract(2, 'days').format('YYYY-MM-DD HH:mm:ss')).length}}
                </b-badge>
                <b-badge variant="warning">
                  {{subject.shippings.filter(x => x.status_history[0].created_at < moment().utc().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss') && x.status_history[0].created_at > moment().utc().subtract(2, 'days').format('YYYY-MM-DD HH:mm:ss')).length}}
                </b-badge>
                <b-badge variant="success">
                  {{subject.shippings.filter(x => x.status_history[0].created_at < moment().utc().subtract(6, 'hours').format('YYYY-MM-DD HH:mm:ss') && x.status_history[0].created_at > moment().utc().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')).length}}
                </b-badge>
              </div>
              <hr class="my-1" />
              <div>{{subject.companies.join(', ')}}</div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-container>
</template>

<script>
import Zenscroll from 'zenscroll'

export default {
  name: 'whIncidencesMonitor',
  data() {
    return {
      couriers: [],
      filterWarehouse: null,
      warehouses: [],
      warehouse: null,
      window: window,
      countryOverride: null,
      averageSpeed: 35,
      timeout: null,
      intervalCountdown: null,
      countdown: 60,
      connectionError: false,
      intervalConnectionError: null,
      countdownConnectionError: 10,
      working: false,
      statuses: ['error', 'processing', 'ready'],
      viewType: 'tv',
      countdownChangeScreen: 20,
      intervalChangeScreen: null,
      currentScreen: 0,
      screenScroller: null
    }
  },
  watch: {
    filterWarehouse(val) {
      if (val && this.countryOverride) {
        this.warehouse = this.warehouses.find(x => x.place_id === val)
        this.getIncidences()
      } else {
        this.clearTimeout()
        this.couriers = []
      }
    },
    countryOverride(val) {
      if (val) {
        this.getIncidences()
      } else {
        this.clearTimeout()
        this.couriers = []
      }
    },
    viewType(val) {
      this.setIntervalChangeScreen()
    }
  },
  mounted() {
    this.countryOverride = this.$cookies.get('country') && !this.$cookies.get('bypassCountry') ? this.$cookies.get('country') : null
    this.filterWarehouse = this.$cookies.get('warehouse') || null
    this.setNewCountry()
    this.setIntervalChangeScreen()
  },
  methods: {
    setIntervalChangeScreen() {
      if (this.viewType === 'tv') {
        this.countdownChangeScreen = this.couriers.length * 2
        this.countdownChangeScreen = this.countdownChangeScreen > 30 ? 30 : (this.countdownChangeScreen === 0 ? 3 : (this.countdownChangeScreen < 10 ? 10 : this.countdownChangeScreen))
        this.intervalChangeScreen = setTimeout(function () {
          this.screenScroller = null
          this.currentScreen = this.currentScreen === this.statuses.length - 1 ? 0 : this.currentScreen + 1
          this.$nextTick(() => {
            if (!this.isInViewport(document.getElementById('inner-monitor'))) {
              this.scrollDown()
            }
          })
          this.setIntervalChangeScreen()
        }.bind(this), this.countdownChangeScreen * 1000)
      } else {
        clearTimeout(this.intervalChangeScreen)
        this.screenScroller = this.screenScroller ? this.screenScroller.stop() : null
      }
    },
    scrollDown() {
      this.screenScroller = Zenscroll.createScroller(document.getElementById('monitor'), this.countdownChangeScreen / 2 * 1000, 50)
      this.screenScroller.toY(document.querySelector('#inner-monitor').offsetHeight - window.innerHeight, this.countdownChangeScreen / 2 * 1000, () => { this.scrollUp() })
    },
    scrollUp() {
      this.screenScroller = Zenscroll.createScroller(document.getElementById('monitor'), this.countdownChangeScreen / 2 * 1000, 50)
      this.screenScroller.to(document.getElementById('monitor'), this.countdownChangeScreen / 2 * 1000, () => { this.screenScroller = null })
    },
    clearTimeout() {
      this.connectionError = false
      clearTimeout(this.timeout)
      clearInterval(this.intervalCountdown)
      clearInterval(this.intervalConnectionError)
      this.countdown = 60
    },
    setIntervalCountdown() {
      clearInterval(this.intervalCountdown)
      this.countdown = 60
      this.intervalCountdown = setInterval(function () {
        this.countdown = this.countdown === 0 ? 0 : this.countdown - 1
      }.bind(this), 1000)
      if (!this.intervalChangeScreen) {
        this.setIntervalChangeScreen()
      }
    },
    setIntervalCountdownConnectionError() {
      clearInterval(this.intervalConnectionError)
      this.countdownConnectionError = 10
      this.intervalConnectionError = setInterval(function () {
        this.countdownConnectionError = this.countdownConnectionError === 0 ? 0 : this.countdownConnectionError - 1
      }.bind(this), 1000)
    },
    getIncidences() {
      if (this.countryOverride && this.filterWarehouse) {
        this.working = true
        let params = {
          includes: [
            'status_history',
            'courier.courier_available.tracking'
          ],
          sort: [
            {
              key: 'updated_at',
              direction: 'asc'
            }
          ],
          filter_groups: [
            {
              filters: [
                ['status', 'eq', 'INCIDENCE'],
                ['updated_at', 'lte', this.moment().utc().subtract(6, 'hours').format('YYYY-MM-DD HH:mm:ss')],
                ['courier_id', 'eq', 'null', 'true']
              ]
            }
          ]
        }

        if (!this.$cookies.get('bypassCountry')) {
          params.filter_groups.push(
            {
              filters: [
                ['from_country_iso_code', 'eq', window.country]
              ]
            }
          )
        }

        if (this.filterWarehouse) {
          params.filter_groups.push(
            {
              filters: [
                ['last_known_place_id', 'eq', this.filterWarehouse]
              ]
            }
          )
        }

        return this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
          .then(response => {
            let byCourier = {}
            response.body.data.forEach((item, i) => {
              if (!byCourier[item.courier.name]) {
                byCourier[item.courier.name] = item.courier
                byCourier[item.courier.name].failed = 1
                byCourier[item.courier.name].shippings = [item]
                byCourier[item.courier.name].companies = [item.company.name]
                byCourier[item.courier.name].roles = [
                  {
                    name: 'courier'
                  }
                ]
              } else {
                if (!byCourier[item.courier.name].failed) {
                  byCourier[item.courier.name].failed = 1
                } else {
                  byCourier[item.courier.name].failed = byCourier[item.courier.name].failed + 1
                  byCourier[item.courier.name].shippings.push(item)
                  byCourier[item.courier.name].companies.push(item.company.name)
                  byCourier[item.courier.name].companies = [...new Set(byCourier[item.courier.name].companies)] // cleanup dupes
                }
              }

              byCourier[item.courier.name].bg = 'success-light'
              byCourier[item.courier.name].fg = 'black'
              if (byCourier[item.courier.name].shippings.filter(x => x.status_history[0].created_at < this.moment().utc().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss') && x.status_history[0].created_at > this.moment().utc().subtract(2, 'days').format('YYYY-MM-DD HH:mm:ss')).length > 0) {
                byCourier[item.courier.name].bg = 'warning-light'
                byCourier[item.courier.name].fg = 'black'
              }
              if (byCourier[item.courier.name].shippings.filter(x => x.status_history[0].created_at < this.moment().utc().subtract(2, 'days').format('YYYY-MM-DD HH:mm:ss')).length > 0) {
                byCourier[item.courier.name].bg = 'danger-light'
                byCourier[item.courier.name].fg = 'black'
              }
              try {
                byCourier[item.courier.name].distanceToDestination = this.setDistanceToDestination(item)
                byCourier[item.courier.name].readableDistanceToDestination = this.distance(byCourier[item.courier.name].distanceToDestination, true)
                const minutes = byCourier[item.courier.name].distanceToDestination / 1000 * 60 / this.averageSpeed
                byCourier[item.courier.name].eta = this.moment().startOf('day').add(minutes, 'minutes').format(minutes < 60 ? 'm' : 'hh:mm') + (minutes < 60 ? ' min' : ' hs')
              } catch (e) {
                byCourier[item.courier.name].distanceToDestination = 100000000000
                byCourier[item.courier.name].readableDistanceToDestination = null
              }
            })

            this.couriers = Object.keys(byCourier).sort((a, b) => {
              if (byCourier[a].distanceToDestination === null) {
                return 1
              } else if (byCourier[b].distanceToDestination === null) {
                return -1
              }
              return byCourier[a].distanceToDestination - byCourier[b].distanceToDestination
            }).map(key => byCourier[key])

            this.working = false
            this.timeout = setTimeout(function () {
              this.getIncidences()
            }.bind(this), 60000)
            this.setIntervalCountdown()
          })
      }
    },
    isInViewport (elem) {
      let bounding = elem.getBoundingClientRect()
      return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    },
    setDistanceToDestination(subject) {
      return subject.courier && subject.courier.courier_available && subject.courier.courier_available.tracking.length > 0 ? this.getDistance({lat: this.warehouse.place.lat, lng: this.warehouse.place.lng}, {lat: subject.courier.courier_available.tracking[0].lat, lng: subject.courier.courier_available.tracking[0].lng}) : null
    },
    setNewCountry() {
      if (this.countryOverride !== null) {
        this.fetchWarehouses(this.countryOverride)
        this.filterWarehouse = null
        this.couriers = []
      } else {
        this.warehouses = []
        this.filterWarehouse = null
      }
    }
  }
}
</script>

<style lang="scss">
.wh-incidences-monitor {
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10000;
  overflow: auto;
  line-height: 1.3;
  .card {
    box-shadow: none !important;
  }
  .card-body {
    padding: 5px !important;
  }
}
#modalConfigMonitor___BV_modal_outer_ {
  z-index: 10040 !important
}
</style>
